export default "__VITE_ASSET__dztbNbb$__"